var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin_1_",
    "data-name": "linkedin (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.946,
    height: 71.946,
    viewBox: "0 0 71.946 71.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6954",
    "data-name": "Group 6954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6953",
    "data-name": "Group 6953"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1256",
    "data-name": "Ellipse 1256",
    cx: 3.27,
    cy: 3.27,
    r: 3.27,
    transform: "translate(22.892 22.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1588",
    "data-name": "Rectangle 1588",
    width: 6.541,
    height: 17.987,
    transform: "translate(22.892 31.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15535",
    "data-name": "Path 15535",
    d: "M35.973,0A35.973,35.973,0,1,0,71.946,35.973,35.973,35.973,0,0,0,35.973,0Zm0,68.676a32.7,32.7,0,1,1,32.7-32.7A32.7,32.7,0,0,1,35.973,68.676Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15536",
    "data-name": "Path 15536",
    d: "M244.763,221.091c-4.905,0-5.494,2.911-5.494,2.911v-2.911h-6.541v17.987h6.541v-9.811s0-3.27,2.78-3.27c1.635,0,2.126,1.455,2.126,3.27v9.811h6.54v-9.811C250.714,224.149,248.491,221.091,244.763,221.091Z",
    transform: "translate(-200.025 -190.023)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.edce58c2ae7c1dd779c56c9421aea46a.svg";
export { ForwardRef as ReactComponent };